module.exports = __webpack_public_path__ + "static/img/nykart-pillow2-2x.109c9c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nykart-pillow2-2x.png
// module id = muQN
// module chunks = 0